import React from "react";
import { GarantiasVehicularInmobiliariaResponse } from "@interfaces/response";
import { Typography } from "@mui/material";

interface GuaranteeTitleProps {
  guarantee_item: GarantiasVehicularInmobiliariaResponse;
  guarantee_index: number;
}

const GuaranteeTitle = (props: GuaranteeTitleProps) => {
  const { details, address, property_type } = props.guarantee_item;
  const { make, model, year, version } = details || {};

  if (details && make && model && year && version) {
    return (
      <Typography variant="h6" fontWeight={600}>
        {make} {model} {year} {version}
      </Typography>
    );
  }

  return (
    <React.Fragment>
      <Typography variant="h6" fontWeight={600} color={"primary.dark"}>
        {property_type?.name || `Garantía ${props.guarantee_index + 1}`}
      </Typography>
      {address && (
        <Typography variant="body1" fontWeight={400} color={"text.secondary"}>
          {address}
        </Typography>
      )}
    </React.Fragment>
  );
};

export default GuaranteeTitle;
